import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { BaseButton } from '@bnnvara/buttons';
import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { FetchCards } from '../../../api/queries/cards.gql';
import Link from '../../Link';
import Paginator from '../../Paginator';
import BaseCategoryCard from '../CategoryCard';

const CategoryCard = React.forwardRef((props, forwardedRef) => {
  const { url } = props;

  return (
    <GridItem
      ref={forwardedRef}
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      key={url}
    >
      <Link href={url}>
        <BaseCategoryCard {...props} />
      </Link>
    </GridItem>
  );
});

CategoryCard.defaultProps = {
  url: null,
};

CategoryCard.propTypes = {
  url: PropTypes.string,
};

const loadMoreButton = (
  <BaseButton variant="underline">
    <span
      onClick={() => {
        track('cardsoverzicht', 'click', 'toon-meer-cards');
      }}
      onKeyDown={() => {
        track('cardsoverzicht', 'click', 'toon-meer-cards');
      }}
      role="button"
      tabIndex={0}
    >
      Toon meer
    </span>
  </BaseButton>
);

const CardOverview = ({ title, slug, limit }) => {
  const { slug: brandSlug } = useBrand();

  return (
    <Fragment>
      <GridItem columnEndSm="span 12">
        <Heading element="h1" variant="brand">
          {title}
        </Heading>
      </GridItem>
      <Paginator
        limit={limit}
        ItemComponent={CategoryCard}
        query={FetchCards}
        variables={{
          slug,
          brandSlug,
        }}
        itemsKey="brand.cards"
        loadMoreElement={loadMoreButton}
      />
    </Fragment>
  );
};

CardOverview.defaultProps = {
  limit: 8,
};

CardOverview.propTypes = {
  limit: PropTypes.number,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

export default CardOverview;
